import { SideMenuPageLayout } from '../components/SideMenuPageLayout/SideMenuPageLayout';
import type { PageSectionGroup } from '../components/SideMenuPageLayout/SideMenuPageLayout';
import { BOOKINGS_SEGMENTS } from '../routes/routeConstants';

export const BookingsPage = () => {
  // Relative targets resolve under the location-scoped /locations/:id/bookings route.
  const groups: PageSectionGroup[] = [
    {
      sections: BOOKINGS_SEGMENTS.map((segment) => ({
        to: segment,
        labelKey: `bookings-menu-${segment}`
      }))
    }
  ];

  return <SideMenuPageLayout headingKey="bookings-header" groups={groups} />;
};
